var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveUsersWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.09,34.26c0.22,1.37,0.29,2.74,0.67,4.02c1.69,5.77,5.52,9.31,11.39,10.62c0.53,0.12,0.83,0.3,0.95,0.84 c0.28,1.23,0.82,2.44,0.88,3.68c0.13,2.71-2.13,4.97-4.85,4.99c-4.84,0.03-9.69,0.01-14.53,0.01c-8.2,0-16.41,0-24.61,0 c-2.49,0-4.51-1.56-4.97-3.99c-0.16-0.81-0.1-1.73,0.14-2.52c1.31-4.3,2.69-8.57,4.08-12.85c1.33-4.09,5.67-6.25,9.68-4.76 c4.26,1.58,8.63,2.16,13.14,1.8c2.56-0.2,5.06-0.75,7.48-1.65C35.74,34.38,35.95,34.31,36.09,34.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.57,18.44c0.03-7.15,5.83-12.92,12.96-12.88c7.06,0.04,12.81,5.82,12.82,12.91 c0.01,7.05-5.86,12.91-12.91,12.89C18.34,31.34,12.54,25.51,12.57,18.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.08,34.48c-0.01,6.81-5.45,12.18-12.3,12.16c-6.53-0.02-12.03-5.59-12.01-12.17 c0.02-6.72,5.5-12.17,12.22-12.14C57.73,22.37,63.09,27.76,63.08,34.48z M48.48,35.47c-0.6-0.62-1.17-1.23-1.75-1.82 c-1.01-1.01-2.36-1.07-3.29-0.17c-0.96,0.93-0.93,2.3,0.09,3.33c1.07,1.08,2.15,2.16,3.23,3.23c1.15,1.14,2.41,1.15,3.56,0 c1.63-1.62,3.25-3.25,4.87-4.87c1.09-1.09,2.19-2.18,3.27-3.28c0.7-0.72,0.86-1.67,0.45-2.54c-0.4-0.86-1.27-1.42-2.24-1.24 c-0.57,0.11-1.18,0.43-1.6,0.84C52.88,31.07,50.74,33.23,48.48,35.47z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUsersWhite);
export default __webpack_public_path__ + "static/media/active_users_white.ac56c68d91af15d4cc2428645449823a.svg";
export { ForwardRef as ReactComponent };